// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=ac654d0c-9f8e-4177-a120-b0df5caa3f0e";
};